import isArray from 'lodash-es/isArray'
import isUndefined from 'lodash-es/isUndefined'
import isNull from 'lodash-es/isNull'
export async function getDataUrl( file ) {
  const reader = new FileReader()
  reader.onload = function (e) {
  }
  reader.readAsDataURL( file )
  return reader.result
}

export function getObjectPath( object, path ) {
  if ( !isArray( path )) {
    path = path.trim().split('.')
  }
  for ( const node of path ) {
    if ( isUndefined( object )) {
      return object
    }
    try {
      object = object[ node ]
    } catch ( error ) {
      return null
    }
  }
  return object
}

export function preprocessActions( actions, context ) {
  return JSON.parse(
    JSON.stringify( actions )
       .replace(/"\${([^}]+)}"/g, ( _, path ) => {
         const rep = getObjectPath( context, path )
         if ( isUndefined( rep ) || isNull( rep )) {
           return 'null'
         }
         return JSON.stringify( rep )
       })
       .replace(/\${([^}]+)}/g, ( _, path ) => {
         const rep = getObjectPath( context, path )
         if ( isUndefined( rep ) || isNull( rep )) {
           return ''
         }
         return rep
       })
  )
}
